<script>

import { mapActions } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators"; // for validators
import Swal from "sweetalert2";
import AlertError from '@/components/alert_error'
import Attachment from '../../../model/attachment.js';
import appConfig from "@/app.config";

export default {
  components: { AlertError },
  data() {
    return {
      //Page errors.
      errors: [],

      attachment: new Attachment,
      acceptFile: appConfig.acceptFile.attachment,
      submitadd: false,
      loadingButton: false,
    };
  },
  validations: {
    attachment: {
      title_ar: {required, minLength: minLength(2), maxLength: maxLength(300) },
      file: {required},
    },
  },
  methods: {
    ...mapActions("attachment", ['add']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    chnageFile(e){
      this.attachment.File = e.target.files.length > 0 ? e.target.files[0] : null;
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
      this.attachment.reset()
    },
    formAddAttachment(e) {
      this.submitadd = true;
      this.$v.$touch();
      if(this.$v.$error) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];

      this.add(this.attachment.toFormData())
      .then((response)=>{
        Swal.fire({
          title: response.data.message,
          icon: "success",
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonColor: "#74788d",
          cancelButtonText: "اغلاق",
          confirmButtonText: 'نسخ الرابط',
          // allowOutsideClick: false,

          input: 'text',
          inputValue: response.data.data.attachment_url,
          inputLabel: 'انسخ رابط المستند',
          inputAttributes: {
            autocapitalize: 'off',
            autofocus: true,
          },
          customClass: {
            input: 'copy-input',
          },
          preConfirm: (result) => {
            navigator.clipboard.writeText(result)
            return false;
          },
        })

        this.resetForm()
        e.target.reset()
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    },
    unitTest(){
      this.attachment.title_ar = 'test title ar'
      this.attachment.description_ar = 'Test description ar'
    },
  },
  mounted(){
    //in locale dev.
    if(process.env.NODE_ENV == "development") {
      this.unitTest()
    }
  }
};
</script>


<template>

  <b-form @submit.prevent="formAddAttachment">

    <AlertError :errors="errors"></AlertError>

    <div class="row mt-3">

      <b-form-group class="col-md-12 mb-3" label="عنوان المستند : " label-for="title_ar" >
        <b-form-input id="title_ar" v-model.trim="attachment.title_ar" :class="{ 'is-invalid': submitadd && $v.attachment.title_ar.$error }" placeholder="ادخل عنوان المستند" type="text" ></b-form-input>
        <div v-if="submitadd && $v.attachment.title_ar.$error" class="invalid-feedback">
          <span v-if="!$v.attachment.title_ar.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.attachment.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.attachment.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group class="col-md-12 mb-3" label="رفع المستند : " label-for="file" >
        <div class="custom_file">
          <b-form-file id="file" v-model="attachment.file" :accept="acceptFile" @change="chnageFile" :class="{ 'is-invalid': submitadd && $v.attachment.file.$error }" placeholder="اختر مستند" ></b-form-file>
          <div v-if="submitadd && $v.attachment.file.$error" class="invalid-feedback">
            <span v-if="!$v.attachment.file.required"> هذا الحقل الزامي </span>
          </div>
        </div>
      </b-form-group>

      <b-form-group class="col-md-12 mb-3" label="وصف المستند : " label-for="description_ar" >
        <textarea id="description_ar" v-model.trim="attachment.description_ar" class="form-control" rows="5" ></textarea>
      </b-form-group>

    </div>

    <div class="mt-3">
      <hr>
      <b-button :disabled="loadingButton" variant="primary" type="submit" class="me-2"> 
        <b-spinner v-if="loadingButton" small></b-spinner>
        <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
      </b-button>
    </div>

  </b-form>

</template>